import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';

const CTASection = () => {
  const services = [
    {
      title: "Audit IA Automobile",
      description: "Évaluation complète de votre potentiel IA dans l\'automobile",
      price: "Gratuit",
      features: [
        "Analyse des processus actuels",
        "Identification des opportunités IA",
        "Roadmap de transformation",
        "ROI estimé des solutions"
      ],
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
        </svg>
      ),
      cta: "Audit Gratuit",
      link: "/contact?service=audit-ia",
      popular: true
    },
    {
      title: "Formation IA Équipes",
      description: "Programme sur-mesure pour former vos équipes à l\'IA automobile",
      price: "Sur devis",
      features: [
        "Formation pratique et théorique",
        "Cas d'usage spécifiques",
        "Certification professionnelle", 
        "Suivi post-formation"
      ],
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
        </svg>
      ),
      cta: "Devis Formation",
      link: "/training-development-services",
      trending: false
    },
    {
      title: "Solution IA Clé en Main",
      description: "Développement et implémentation complète de votre solution IA",
      price: "À partir de €25K",
      features: [
        "Développement sur-mesure",
        "Intégration systèmes existants",
        "Formation utilisateurs",
        "Support et maintenance"
      ],
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9"/>
        </svg>
      ),
      cta: "Commencer le Projet",
      link: "/ai-solutions-integration-hub",
      trending: false
    }
  ];

  const testimonials = [
    {
      quote: "Grâce à CRF PERFECTION, nous avons réduit nos coûts de maintenance de 65% avec l'IA prédictive.",
      author: "Marie Traoré",
      position: "DG AutoExcellence CI",
      avatar: "MT"
    },
    {
      quote: "La formation IA de CRF PERFECTION a transformé notre approche commerciale. +120% de ventes!",
      author: "Kwame Asante", 
      position: "Dir. Commercial MegaMotors",
      avatar: "KA"
    },
    {
      quote: "ROI de 420% en 10 mois avec leur solution d\'optimisation logistique IA. Remarquable!",
      author: "Fatou Diop",
      position: "CEO FleetMaster",
      avatar: "FD"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main CTA Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-green-100 text-green-800 text-sm font-medium mb-4">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
            Passons à l'Action
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Transformez Votre Business Automobile avec 
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600"> l'IA</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
            Vous avez lu comment l'IA révolutionne l'industrie automobile. Maintenant, découvrez comment 
            CRF PERFECTION peut vous accompagner dans votre transformation digitale.
          </p>

          {/* Company Trust Indicators */}
          <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 text-gray-600 text-sm">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <Image
                  src="/assets/images/logo_CRF_PERFECTION_4x-1761998753526.png"
                  alt="CRF PERFECTION logo featuring interlocking heart-shaped design in red and gold colors representing Centre de Recherche et de Formation business therapy excellence"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="font-semibold">CRF PERFECTION</span>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <span>50+ Entreprises Transformées</span>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
              </svg>
              <span>ROI Moyen: +285%</span>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
              </svg>
              <span>Excellence Africaine</span>
            </div>
          </div>
        </div>

        {/* Services Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {services?.map((service, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden ${
                service?.popular ? 'ring-2 ring-purple-500' : 'border border-gray-200'
              }`}
            >
              {/* Popular Badge */}
              {service?.popular && (
                <div className="absolute top-0 right-0 bg-purple-500 text-white px-4 py-1 text-xs font-bold rounded-bl-lg">
                  POPULAIRE
                </div>
              )}

              <div className="p-6">
                {/* Service Icon */}
                <div className="w-12 h-12 bg-gradient-to-r from-purple-600 to-blue-600 rounded-xl flex items-center justify-center text-white mb-4">
                  {service?.icon}
                </div>

                {/* Service Info */}
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service?.title}</h3>
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">{service?.description}</p>
                
                {/* Price */}
                <div className="mb-6">
                  <span className="text-2xl font-bold text-purple-600">{service?.price}</span>
                </div>

                {/* Features */}
                <ul className="space-y-2 mb-6">
                  {service?.features?.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center space-x-2 text-sm text-gray-700">
                      <svg className="w-4 h-4 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                      </svg>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <Link
                  to={service?.link}
                  className={`block w-full text-center py-3 px-4 rounded-lg font-semibold transition-all duration-300 ${
                    service?.popular
                      ? 'bg-gradient-to-r from-purple-600 to-blue-600 text-white hover:from-purple-700 hover:to-blue-700 shadow-lg hover:shadow-xl'
                      : 'bg-gray-100 text-gray-700 hover:bg-purple-100 hover:text-purple-700 border border-gray-200'
                  }`}
                >
                  {service?.cta}
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">
            Ce Que Disent Nos Clients
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials?.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                <div className="mb-4">
                  <svg className="w-6 h-6 text-purple-400 mb-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z"/>
                  </svg>
                  <p className="text-gray-700 italic text-sm leading-relaxed">
                    "{testimonial?.quote}"
                  </p>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-sm">{testimonial?.avatar}</span>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 text-sm">{testimonial?.author}</div>
                    <div className="text-gray-600 text-xs">{testimonial?.position}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Final CTA */}
        <div className="bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 rounded-3xl p-8 md:p-12 text-center text-white relative overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2240%22%20height%3D%2240%22%20viewBox%3D%220%200%2040%2040%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill%3D%22%23ffffff%22%20fill-opacity%3D%220.1%22%3E%3Cpath%20d%3D%22M20%2020.5V18H0v-2h20v2.5zm-.5%200h-2v-2H20v2zm-.5%200h-2v-2H20v2z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E')]"></div>
          </div>

          <div className="relative">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Prêt à Rejoindre la Révolution IA Automobile ?
            </h3>
            <p className="text-blue-100 mb-8 max-w-2xl mx-auto leading-relaxed">
              Ne laissez pas vos concurrents prendre l'avantage. Contactez nos experts CRF PERFECTION dès aujourd'hui 
              pour une consultation gratuite et découvrez votre potentiel de transformation IA.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto mb-8">
              <Link
                to="/contact?service=consultation-ia"
                className="px-8 py-3 bg-white text-purple-600 font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Consultation Gratuite
              </Link>
              <button className="px-8 py-3 bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold rounded-lg hover:bg-white/20 transition-all duration-300">
                Télécharger le Guide IA
              </button>
            </div>

            {/* Contact Info */}
            <div className="text-blue-200 text-sm">
              <p>📧 ai-automotive@crfperfection.com</p>
              <p>📞 +33 1 23 45 67 89</p>
              <p>⏰ Réponse garantie sous 24h</p>
            </div>
          </div>

          {/* Decorative Elements */}
          <div className="absolute top-10 left-10 w-20 h-20 bg-purple-600/20 rounded-full blur-xl"></div>
          <div className="absolute bottom-10 right-10 w-32 h-32 bg-blue-600/20 rounded-full blur-xl"></div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;